import React from "react"
import { map, isPresent } from 'lodash'
import { Dropdown } from "react-bootstrap";

const PageBreadcrumbs = ({ breadcrumbs }) => (
  <nav aria-label="breadcrumb">
    <ol className="breadcrumb">
      {map(breadcrumbs, breadcrumb => {
        if (isPresent(breadcrumb.options.breadcrumbs)) {
          return (
            <li key={breadcrumb.name} className='breadcrumb-item'>
              <Dropdown>
                <Dropdown.Toggle className='p-0' variant="link" id="dropdown-basic">
                  {breadcrumb.name}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {map(breadcrumb.options.breadcrumbs, breadcrumbItem => (
                    <Dropdown.Item href={breadcrumbItem.href}>{breadcrumbItem.name}</Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </li>
          )
        }


        return (
          <li key={breadcrumb.name} className={`breadcrumb-item ${true ? '' : 'active'}`}>
            <a className='p-0 btn btn-link' href={breadcrumb.path}>{breadcrumb.name}</a>
          </li>
        )
      })}
    </ol>
  </nav>
)

export default PageBreadcrumbs
